<template>
      <div class="modal2" v-show="value">
      
       <b-form-group label="Set up a deck of cards">
        <div class="container" style="position:relative">
          
		  	<span class="rightmenu dlgbutton" style="position: absolute; right: 1rem;"> 
	        	<b-button v-on:click="closeLabel" variant="danger">
	        		<b-icon  icon="x"></b-icon>
	        		Cancel
	        	</b-button>	        	
	        </span>
	        <h1>Set up a deck of cards</h1>	        
	        
	    	<b-form-group label="Deck type">
		      <b-form-radio-group
		        id="btn-radios-size"
		        v-model="deckType"	        
		        buttons
		        button-variant="outline-primary"
		        size="lg"
		        name="radio-btn-outline"
		      >	
		      	<b-form-radio value="">Empty</b-form-radio>		      	      
		      	<b-form-radio value="lotr-tile">Lord of the Rings (Event tiles)</b-form-radio>
		      	<b-form-radio value="lotr-card">Lord of the Rings (Hobbit cards)</b-form-radio>
		      	<b-form-radio value="si-minor">Spirit island (minor power)</b-form-radio>
		      	<b-form-radio value="si-major">Spirit island (major power)</b-form-radio>
		      </b-form-radio-group>
		    </b-form-group>
		    
		    
		    <span>
			    <b-form-group label="What is this deck used for?">
			      <b-form-radio-group
			        id="btn-radios-size"
			        v-model="deckUse"	        
			        buttons
			        button-variant="outline-primary"
			        size="lg"
			        name="radio-btn-outline"
			      >	      
			      	<b-form-radio value="hand">My hand</b-form-radio>
			      	<b-form-radio value="draw">Draw pile</b-form-radio>
			      	<b-form-radio value="discard">Discard pile</b-form-radio>
			      </b-form-radio-group>
			    </b-form-group>
			    
		   <span v-if="deckType=='' && deckUse=='draw'">
		     	<b-form-group label="Label this deck">
				<div v-if="rect !== null" ><textarea rows="1" cols="40"v-model="editedText" placeholder="Describe your deck"></textarea></div>
				 </b-form-group>
		    </span>
		    
		    <span v-if="deckUse=='hand'">
		    	<b-form-group label="Hand limit">
			      <b-form-radio-group
			        id="btn-radios-size"
			        v-model="deckLimit"	        
			        buttons
			        button-variant="outline-primary"
			        size="lg"
			        name="radio-btn-outline"
			      >	      
			      	<b-form-radio value="0">No limit</b-form-radio>
			      	<b-form-radio value="7">7 cards</b-form-radio>
			      </b-form-radio-group>
			    </b-form-group>
		    </span>
		    
			    <span v-if="deckUse!='hand'">
			        <b-form-group label="Number of cards taken at a time">
				      <b-form-radio-group
				        id="btn-radios-size"
				        v-model="cardsDrawn"	        
				        buttons
				        button-variant="outline-primary"
				        size="lg"
				        name="radio-btn-outline"
				      >	      
				        <b-form-radio value="0">Cannot take</b-form-radio>
				      	<b-form-radio value="1">1</b-form-radio>
				      	<b-form-radio value="2">2</b-form-radio>
				      	<b-form-radio value="3">3</b-form-radio>
				      	<b-form-radio value="pick">Pick by looking</b-form-radio>
				      </b-form-radio-group>
				    </b-form-group>
				    
				    
				    
			     </span>
			     
			      <b-form-group label="Cards played go to">
				      <b-form-radio-group
				        id="btn-radios-size"
				        v-model="cardsGoTo"	        
				        buttons
				        button-variant="outline-primary"
				        size="lg"
				        name="radio-btn-outline"
				      >	      
				      	<b-form-radio value="hand">My hand</b-form-radio>
				      	<b-form-radio value="discard">Discard pile</b-form-radio>
				      </b-form-radio-group>
				     </b-form-group>
			     
			     <span v-if="deckUse!='discard'">
			     <b-form-group label="Cards discarded go to">
				      <b-form-radio-group
				        id="btn-radios-size"
				        v-model="discardGoTo"	        
				        buttons
				        button-variant="outline-primary"
				        size="lg"
				        name="radio-btn-outline"
				      >	      
				      	<b-form-radio value="bottom">Bottom of this deck</b-form-radio>
				      	<b-form-radio value="discard">Discard pile</b-form-radio>
				      	<b-form-radio value="removed">Removed from game</b-form-radio>
				      	<b-form-radio value="none">No discard</b-form-radio>
				      </b-form-radio-group>
				     </b-form-group>
				 </span>
			     <span v-if="deckUse!='hand'">
			     <b-form-group label="Can you look at the cards in this deck?">
			      <b-form-radio-group
			        id="btn-radios-size"
			        v-model="viewMode"	        
			        buttons
			        button-variant="outline-primary"
			        size="lg"
			        name="radio-btn-outline"
			      >	      
			      	<b-form-radio value="0">Never</b-form-radio>
			      	<b-form-radio value="3">Top 3 only</b-form-radio>
			      	<b-form-radio value="4">Top 4 only</b-form-radio>
			      	<b-form-radio value="5">Top 5 only</b-form-radio>
			      	<b-form-radio value="all">All of them</b-form-radio>
			      </b-form-radio-group>
			    </b-form-group>
			    </span>
			</span>   
		    <b-form-group label="Size">
		      <b-form-radio-group
		        id="btn-radios-size"
		        v-model="labelSize"	        
		        buttons
		        button-variant="outline-primary"
		        size="lg"
		        name="radio-btn-outline"
		      >	      
		      	<b-form-radio value="100">Small</b-form-radio>
		      	<b-form-radio value="150">Medium</b-form-radio>
		      	<b-form-radio value="200">Large</b-form-radio>
		      	<b-form-radio value="300">Huge</b-form-radio>
		      </b-form-radio-group>
		    </b-form-group>
		    
		     <span v-if="deckUse!='hand'">
			<b-form-group label="Location">
		      <b-form-radio-group
		        id="btn-radios-location"
		        v-model="location"	        
		        buttons
		        button-variant="outline-primary"
		        size="lg"
		        name="radio-btn-outline"
		      >	      
		      	<b-form-radio value="board">On the board</b-form-radio>
		      	<b-form-radio value="player">In my player area</b-form-radio>
		      </b-form-radio-group>
		    </b-form-group>
	 		</span>
	        <div class="leftmenu dlgbutton"	> 
	        	<b-button v-on:click="deleteLabel" variant="warning">
	        		<b-icon  icon="exclamation-triangle-fill"></b-icon>
	        	Delete
	        	</b-button>	        	
	        </div>

	        <span class="rightmenu dlgbutton"	>
	        	<b-button v-on:click="savecloseLabel" variant="success">
	        		<b-icon  icon="check2"></b-icon>
	        		OK
	        	</b-button>	        	
	        </span>
	      	<br/>
	      	<br/>
	      	<br/>
        </div>
        </b-form-group>
      
      
      
      
      </div>
     </div>  
    </template>

    <script>
        export default {
            name: 'EditDeck',
            props: {
                value: {
                    required: true
                },
                rect: Object,                             
            },
            data:  function () {
    			return {
    			editedText:"",
    			deckType:"",
    			deckUse:"draw",
    			viewMode: "never",
    			labelSize:200,
    			cardsDrawn:1,
    			location:"player",
    			deckLimit:0,
    			cardsGoTo:"discard",
    			discardGoTo:"removed"
    			}
    		},
            watch: { 
		      	value: function() { // reload data when the dialog opens
		          if (this.rect){		          	
			          this.editedText = this.rect.label;
			          if (this.rect.deckType)
			            this.deckType = this.rect.deckType;
			          if (this.rect.deckUse)
			            this.deckUse = this.rect.deckUse;
			          if (this.rect.cardsDrawn)
			            this.cardsDrawn = this.rect.cardsDrawn;
			          if (this.rect.viewMode)
			            this.viewMode = this.rect.viewMode;	 
			          if (this.rect.deckLimit)
			            this.deckLimit = this.rect.deckLimit;
			          if (this.rect.cardsGoTo)
			            this.cardsGoTo = this.rect.cardsGoTo;
			           if (this.rect.discardGoTo)
			            this.discardGoTo = this.rect.discardGoTo;	 
			                       
			          this.labelSize = this.rect.width;
			          this.location = this.rect.location;
			         
		          }
		        }
		      },
            methods: {
                closeLabel() {                	
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                },
                savecloseLabel() {
                	if (this.rect){
                		this.rect.label = this.editedText;                		
                		this.rect.width = parseInt(this.labelSize);
                		this.rect.height = parseInt(this.labelSize);
                		this.rect.deckType = this.deckType;
                		this.rect.deckUse = this.deckUse;
                		this.rect.cardsDrawn = this.cardsDrawn;
                		this.rect.viewMode = this.viewMode;
                		this.rect.location = this.location;
                		this.rect.cardsGoTo = this.cardsGoTo;
                		this.rect.discardGoTo = this.discardGoTo;
                		if (this.deckUse=="hand")
                		{
                			this.rect.label = "Hand";
                			this.rect.location="player";
                			this.rect.cardsDrawn="pick";
                			this.rect.viewMode="all";                			
                		}
                		else if (this.deckUse=="discard")
                		{
                			this.rect.label = "Discard";
                		}
                		else
                		{            		
	                		if (this.deckType=="lotr-tile"){
	                		 this.rect.label = "Event";
	                		}
	                		if (this.deckType=="lotr-card"){
	                		 this.rect.label = "Hobbit";
	                		}
	                		if (this.deckType=="si-minor"){
	                		 this.rect.label = "Minor";
	                		}
	                		if (this.deckType=="si-major"){
	                		 this.rect.label = "Major";
	                		}
                		}
	               		 if (this.location == "player")
				          	this.rect.owner = this.$parent.$parent.userId;
			          
                	}
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                    this.$emit("edited", this.rect);
                },
                deleteLabel() {
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                    this.$emit("deleted", this.rect);
                }             
            }
        };
    </script>


    <style lang="css" scoped>
    	h1 {
    		padding:20px;
    	}
    	
    .menuitem img{height: 64px;  margin-top:2px;}
    .menubar {height:72px;background:#fff; border:1px solid lightgrey; background-color:#eee;}
	
    
        .modal2 {
          background-color: rgba(0, 0, 0, 0.7);
          position: absolute;
  		  top: 0;
  		  right: 0;   
  		  left: 0;
  		  bottom: 0;         
      }
      
      .container{
      	background-color: #fff;
      	margin:50px;
      }
      
      textarea {font:Verdana;
      	font-size:30px;
      	}
      	
      .radiobuttons {
      margin:20px;      
      }
      
      .dlgbutton {
      	margin:20px;
      }
      	
    </style>